import { render } from "./LoginPassword.vue?vue&type=template&id=419d7d63&scoped=true"
import script from "./LoginPassword.vue?vue&type=script&lang=js"
export * from "./LoginPassword.vue?vue&type=script&lang=js"

import "./LoginPassword.vue?vue&type=style&index=0&id=419d7d63&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/zamon-vue/zamon-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-419d7d63"]])

export default __exports__